import movementRepository from "../repositories/MovementRepository";

export class MovementService {
  static GetConfirmationTemplates(instance) {
    const repo = new movementRepository;
    return repo.getConfirmationTemplates(instance).then();
  }

  static SendConfirmation(instance, payload) {
    const repo = new movementRepository;
    return repo.sendConfirmation(instance, payload).then();
  }

  static SendConfirmationEmail(instance, payload) {
    const repo = new movementRepository;
    return repo.sendConfirmationEmail(instance, payload).then();
  }

  static UpdateMovement(instance, payload) {
    const repo = new movementRepository;
    return repo.updateMovement(instance, payload).then();
  }

  static GetMaxPay(instance, orderId) {
    const repo = new movementRepository;
    return repo.getMaxPay(instance, orderId).then();
  }
}